import Vue from 'vue';
import Router from 'vue-router';
import index from '@/view/index'; //首页

const yogaPractice = (resolve) =>
  require(['../view/yogaPractice.vue'], resolve); //瑜伽练习
const yogaPracticeClassify = (resolve) =>
  require(['../view/yogaPractice-classify.vue'], resolve);
const yogaPracticePlan = (resolve) =>
  require(['../view/yogaPractice-plan.vue'], resolve);

const yogaUniversity = (resolve) =>
  require(['../view/yogaUniversity.vue'], resolve); //瑜乐大学
const yogaUniversityRyt = (resolve) =>
  require(['../view/yogaUniversity-RYT.vue'], resolve); //瑜乐大学-RYT
const yogaUniversityWorkshop = (resolve) =>
  require(['../view/yogaUniversity-workshop.vue'], resolve); //瑜乐大学 -工作坊
const yogaUniversityLearnto = (resolve) =>
  require(['../view/yogaUniversity-learnto.vue'], resolve); //瑜乐大学-游学
const yogaUniversityTrain = (resolve) =>
  require(['../view/yogaUniversity-train.vue'], resolve); //瑜乐大学 -线上训练
const yogaUniversityCredential = (resolve) =>
  require(['../view/yogaUniversity-credential.vue'], resolve); //瑜乐大学 - 证书查询
const yogaUniversityDetail = (resolve) =>
  require(['../view/yogaUniversity-detail.vue'], resolve); //瑜乐大学-课程详情

const teacherCooperation = (resolve) =>
  require(['../view/teacherCooperation.vue'], resolve); //名师合作
const teacherCooperationDetail = (resolve) =>
  require(['../view/teacherCooperation-detail.vue'], resolve); //名师详情

const mall = (resolve) => require(['../view/mall.vue'], resolve); //装备

const aboutUs = (resolve) => require(['../view/aboutUs.vue'], resolve); //关于我们
const honor = (resolve) => require(['../view/honor.vue'], resolve); //获奖荣誉
const contactUs = (resolve) => require(['../view/contactUs.vue'], resolve); //联系我们
const joinUs = (resolve) => require(['../view/joinUs.vue'], resolve); //加入我们
const serviceTerms = (resolve) =>
  require(['../view/serviceTerms.vue'], resolve); //服务条款
const statement = (resolve) => require(['../view/statement.vue'], resolve); //隐私声明
const theMedias = (resolve) => require(['../view/theMedias.vue'], resolve); //媒体报道
const theMediasDetail = (resolve) =>
  require(['../view/theMediasDetail.vue'], resolve); //媒体报道详情
const linkOther = (resolve) => require(['../view/linkOther.vue'], resolve); //跳转到每日瑜伽app扫码

Vue.use(Router);

var base = /127.0.0.1|localhost|dailyyoga.com.cn|mirror.dailyyoga.com.cn/.test(
  window.location.hostname,
)
  ? ''
  : '/front_end_all/website_h2_v2';

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: base + '/',
      name: 'index',
      component: index,
    },
    {
      path: base + '/yogaPractice',
      name: 'yogaPractice',
      component: yogaPractice,
    },
    {
      path: base + '/yogaPractice/:id',
      name: 'yogaPracticeClassify',
      component: yogaPracticeClassify,
    },
    {
      path: base + '/yogaPracticePlan/:title',
      name: 'yogaPracticePlan',
      component: yogaPracticePlan,
    },
    {
      path: base + '/yogaUniversity',
      name: 'yogaUniversity',
      component: yogaUniversity,
      children: [
        {
          path: '',
          name: 'yogaUniversityRyt',
          component: yogaUniversityRyt,
        },
        {
          path: 'workshop',
          name: 'yogaUniversityWorkshop',
          component: yogaUniversityWorkshop,
        },
        {
          path: 'learnto',
          name: 'yogaUniversityLearnto',
          component: yogaUniversityLearnto,
        },
        {
          path: 'train',
          name: 'yogaUniversityTrain',
          component: yogaUniversityTrain,
        },
        {
          path: 'credential',
          name: 'yogaUniversityCredential',
          component: yogaUniversityCredential,
        },
      ],
    },
    {
      path: base + '/yogaUniversityDetail/:type/:id',
      name: 'yogaUniversityDetail',
      component: yogaUniversityDetail,
    },
    {
      path: base + '/teacherCooperation',
      name: 'teacherCooperation',
      component: teacherCooperation,
    },
    {
      path: base + '/teacherCooperationDetail/:title',
      name: 'teacherCooperationDetail',
      component: teacherCooperationDetail,
    },
    {
      path: base + '/mall',
      name: 'mall',
      component: mall,
    },
    {
      path: base + '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
    },
    {
      path: base + '/honor',
      name: 'honor',
      component: honor,
    },
    {
      path: base + '/contactUs',
      name: 'contactUs',
      component: contactUs,
    },
    {
      path: base + '/joinUs',
      name: 'joinUs',
      component: joinUs,
    },
    {
      path: base + '/serviceTerms',
      name: 'serviceTerms',
      component: serviceTerms,
    },
    {
      path: base + '/statement',
      name: 'statement',
      component: statement,
    },
    {
      path: base + '/theMedias',
      name: 'theMedias',
      component: theMedias,
    },
    {
      path: base + '/theMediasDetail/:id/:indexId',
      name: 'theMediasDetail',
      component: theMediasDetail,
    },
    {
      path: base + '/qrcode',
      name: 'linkOther',
      component: linkOther,
    },
    {
      path: '*',
      name: 'index',
      component: index,
    },
  ],
});

//  增加全局守卫来添加query
router.beforeEach((to, from, next) => {
  if (from.query.channels && !to.query.channels) {
    next({
      path: to.path,
      params: to.params,
      query: from.query,
    });
  }
  next();
});

router.afterEach((route) => {
  document.documentElement.scrollTop = document.body.scrollTop = 0;
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js